import { Link } from '@tanstack/react-router'
import { useIntl } from 'react-intl'
import { EarMark } from '@/components/ui/primitives'
import { DEFAULT_LOCALE, isLocale } from '@/i18n/locales'
import { useT } from '@/i18n/use-t'

export function NotFoundPage() {
  const t = useT()
  const current = useIntl().locale
  const locale = isLocale(current) ? current : DEFAULT_LOCALE
  return (
    <main className="flex min-h-dvh flex-col items-center justify-center gap-4 px-6 text-center">
      <EarMark size={40} />
      <h1 className="font-mono text-5xl font-semibold text-rose">404</h1>
      <p className="text-haze">{t('ui.notFound')}</p>
      <Link to="/$locale/today" params={{ locale }} className="text-sm">
        ← {t('nav.today')}
      </Link>
    </main>
  )
}
